import { Star, BadgeCheck, MessageCircleReply, HeartHandshake, MousePointerClick } from "lucide-react";
import { TESTIMONIALS } from "@/config/siteConfig";
import { Reveal } from "@/components/Reveal";

const TRUST = [
  { icon: BadgeCheck, label: "Service professionnel" },
  { icon: MessageCircleReply, label: "Communication rapide" },
  { icon: HeartHandshake, label: "Assistance personnalisée" },
  { icon: MousePointerClick, label: "Processus simple" },
];

export const Testimonials = () => (
  <section id="confiance" className="border-t border-black/5 bg-white py-24 md:py-32" data-testid="trust-section">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-12 max-w-2xl">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">05 — Confiance</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
          Un service sur lequel vous pouvez compter
        </h2>
      </Reveal>

      <Reveal>
        <div className="mb-16 grid grid-cols-2 gap-px overflow-hidden rounded-3xl border border-gray-200 bg-gray-200 lg:grid-cols-4" data-testid="trust-badges">
          {TRUST.map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-3 bg-white px-4 py-8 text-center">
              <item.icon className="h-7 w-7 text-black" />
              <p className="font-display text-sm font-bold text-black">{item.label}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure className="flex h-full flex-col rounded-3xl border border-gray-200 bg-gray-50 p-6" data-testid={`testimonial-${i}`}>
              <div className="flex gap-1" aria-label="5 étoiles">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-jeem-yellow text-jeem-yellow" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-gray-700">« {t.quote} »</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                {t.avatar ? (
                  <img src={t.avatar} alt="" loading="lazy" className="h-10 w-10 rounded-full object-cover" />
                ) : (
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-jeem-yellow font-display text-sm font-bold text-black">
                    {t.name.charAt(0)}
                  </span>
                )}
                <span>
                  <span className="block font-display text-sm font-bold text-black">{t.name}</span>
                  <span className="block text-xs text-gray-500">{t.location}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <p className="mt-6 text-xs italic text-gray-400" data-testid="testimonials-demo-notice">
        * Témoignages d'exemple — contenu temporaire en attendant de vrais avis clients.
      </p>
    </div>
  </section>
);
